<template>
   <!-- [theme class css in cms-themes.scss] -->
   <section
      class="box-border flex size-full min-h-[17rem] flex-col items-center justify-center rounded-xl p-6 text-center md:max-lg:min-h-[31rem] md:max-lg:p-10 lg:max-xl:min-h-[17rem] lg:max-xl:p-12 xl:min-h-[19rem] xl:p-16"
      :class="`theme-${containerTheme}`"
   >
      <h1 class="text-3xl text-lighter">{{ heading }}</h1>
      <PageCTAItems v-if="cta" :ctas="[cta]" :theme="containerTheme" class="mt-4" :isPageCta="false" />
   </section>
</template>

<script lang="ts">
interface SmallCardProps {
   heading: string;
   cta: LinkElementData;
   theme?: ContainerTheme;
}

export type { SmallCardProps };
</script>

<script setup lang="ts">
import type { LinkElementData } from "@/components/ui/LinkElement.vue";
import { Theme, type ContainerTheme } from "@/types";

const props = withDefaults(defineProps<SmallCardProps>(), {
   theme: Theme.Grey,
});

const containerTheme = computed(() => (!props.theme ? Theme.Grey : props.theme));
</script>

<style scoped lang="scss"></style>
